import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#014497',
    },
    secondary: {
      main: '#0288D1',
    },
  },
});
